module.exports = __webpack_public_path__ + "img/collection-weddingRingsMorningGlow@2x.12c32e7.webp";